export const getParamFromCurrentLocation = param => {
  const regexp = new RegExp(`(/${param}/)(.[^/]*)`)
  const { pathname } = window.location

  const matches = pathname.match(regexp)
  return matches && matches.length > 2 ? matches[2] : undefined
}
